<script setup lang="ts">
import type { entry } from "@/types";
import { useStore } from "../stores/dataStore";
import { ref } from "vue";

import EntryDetails from "@/components/EntryDetails.vue";

const dataStore = useStore();

const selectedEntry = ref<entry>();

const filterText = ref("");

function filterSortedEntries() {
  const copy = [...dataStore.entries].filter(
    (x) =>
      x.Customer.name.toLowerCase().includes(filterText.value.toLowerCase()) ||
      x.Customer.street.toLowerCase().includes(filterText.value.toLowerCase()) ||
      x.notes.toLowerCase().includes(filterText.value.toLowerCase()) ||
      ("" + x.id).includes(filterText.value.toLowerCase()),
  );

  copy
    //.sort((a, b) => +a.id - +b.id)
    .sort((a, b) => +b.id - +a.id)
    .sort((a, b) => a.billed.getTime() - b.billed.getTime())
    .sort((a, b) => a.paid.getTime() - b.paid.getTime());
  return copy;
}

function addEntry() {
  const empty = dataStore.entries.find((x) => !x.Customer.name && !x.Customer.street);
  if (empty) {
    selectedEntry.value = empty;
  } else selectedEntry.value = dataStore.createEntry();
}
</script>

<template>
  <main class="flex flex-grow flex-row overflow-hidden">
    <div
      id="entrySelector"
      class="flex h-full min-w-80 flex-col gap-2 overflow-y-auto border-r-4 border-red-600 p-2"
    >
      <div
        class="flex min-h-20 cursor-pointer flex-row items-center rounded-2xl border-4 border-black bg-neutral-600 pr-4 hover:bg-neutral-500"
      >
        <img class="w-12 invert" src="@/assets/filter.svg" />
        <input class="m-auto h-12 grow rounded-xl" v-model="filterText" />
      </div>
      <button
        id="entryAddBtn"
        class="flex min-h-20 cursor-pointer rounded-2xl border-4 border-black bg-neutral-600 hover:bg-neutral-500"
        @click="addEntry"
      >
        <img class="m-auto w-12" src="@/assets/add.svg" />
      </button>

      <div
        :class="selectedEntry?.id == entry.id ? 'border-red-600' : ''"
        class="relative flex min-h-20 cursor-pointer flex-col rounded-2xl border-4 border-black bg-neutral-600 p-1 pl-5 hover:bg-neutral-500"
        v-for="entry in filterSortedEntries()"
        :key="entry.id"
        @click="selectedEntry = entry"
      >
        <span class="text-3xl">{{ entry.Customer.name }}</span>
        <span class="ml-4 text-xl">{{ entry.Customer.street }}</span>
        <span class="absolute right-3 bottom-1">{{ entry.id }}</span>
        <img
          v-if="entry.paid > dataStore.date"
          class="absolute top-0 right-0 w-12 p-2 invert"
          src="@/assets/pay.svg"
        />
        <img
          v-else-if="entry.billed > dataStore.date"
          class="absolute top-0 right-0 w-12 invert"
          src="@/assets/bill.svg"
        />
      </div>
    </div>
    <EntryDetails
      v-if="selectedEntry"
      class="flex-grow"
      :selected-entry="selectedEntry"
      @deselect="selectedEntry = undefined"
    />
  </main>
</template>

<style lang="css" scoped>
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f100;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
